// extracted by mini-css-extract-plugin
export default {"default":"yLHelonWmWn9ry7TnGrB","opened":"E7oBW92c2xHT9llI34Ql","closed":"Z2MTwrObTaVTx45yO3QA"};